<!-- 单独审批列表 -->
<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->

      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">
          <el-form-item label="商户名称">
            <el-select v-model="form.appId" filterable placeholder="--请选择--" :popper-append-to-body="false"
              popper-class="eloption">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="merchant in merchantList" :label="merchant.value + '-' + merchant.name"
                :key="merchant.value" :value="merchant.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="充值状态">
            <el-select v-model="form.status" placeholder="状态">
              <el-option label="请选择" value=""></el-option>
              <el-option label="待审核" value="00"></el-option>
              <el-option label="已通过" value="01"></el-option>
              <el-option label="已拒绝" value="02"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="订单号">
            <el-input v-model="form.orderId" placeholder="订单号"></el-input>
          </el-form-item>

          <el-form-item label="日期">
            <el-date-picker v-model="timeDate" type="daterange" format="yyyy-MM-dd" value-format="yyyyMMdd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange">
            </el-date-picker>
          </el-form-item>
        </template>

        <template slot="tableColumn">
          <el-table-column v-if="$store.state.roleId != '1125110685723868888'" prop="appId" width="140px" label="商户"
            align="center">
            <template slot-scope="{ row }">
              <div>{{ row.appId }}</div>
              <div>{{ row.merchantName }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="amount" label="充值金额=币 x 费率 x 汇率" width="200" :formatter="$formatter.FenToYuan"
            align="center">
            <template slot-scope="{ row }">
              {{ $formatter.FenToYuan(null, null, row.amount, null) }} =
              {{ row.fromAmount }} x {{ row.feeRate ? 1 - row.feeRate : ' ' }} x
              {{ row.exchangeRate ? row.exchangeRate : ' ' }}
            </template>
          </el-table-column>

          <el-table-column prop="status" label="充值状态" width="100px" :formatter="$formatter.formatApprovalStatus"
            align="center">
            <template slot-scope="{ row }">
              <el-tag size="small" :type="row.status == '00'
                ? 'warning'
                : row.status == '01'
                  ? 'success'
                  : 'danger'
                ">{{
    $formatter.formatApprovalStatus(null, null, row.status, null)
  }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column width="160" prop="dealTimeCHN" label="处理时间CN" align="center"></el-table-column>

          <el-table-column width="160" prop="dealTimeFormat" label="处理时间BR" align="center"></el-table-column>

          <el-table-column width="160" prop="approveRemark" label="审批备注" align="center">
            <template slot-scope="{ row }">
              <div v-if="row.approveRemark">
                <el-popover v-if="row.approveRemark && row.approveRemark.length > 10" placement="top-start" width="300"
                  trigger="hover" :content="row.approveRemark">
                  <div style="color: rgb(2, 189, 2);" slot="reference" class="remark" v-if="row.receivedStatus == '1'">
                    {{ row.approveRemark }}
                  </div>
                  <div slot="reference" class="remark" v-else>
                    {{ row.approveRemark }}
                  </div>
                </el-popover>
                <div v-else>{{ row.approveRemark }}</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column width="80" prop="operType" label="操作类型" align="center">
            <template slot-scope="{row}">
              <div @click="handleOperType(row)">
                <el-link type="primary" v-if="!row.operType">正常</el-link>
                <el-link type="success" v-if="row.operType == 1">授信</el-link>
                <el-link type="warning" v-if="row.operType == 3">平移</el-link>
                <el-link type="info" v-if="row.operType == 4">其他</el-link>
              </div>
            </template>
          </el-table-column>

          <el-table-column width="200" prop="paymentAccount" label="打款账号" align="center">
            <template slot-scope="{ row }">
              <div v-if="row.paymentAccount">{{ row.paymentAccount }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column width="200" prop="collectAccount" label="收款账号" align="center"></el-table-column>

          <el-table-column width="250" prop="orderId" label="订单号1" align="center"></el-table-column>

          <el-table-column width="250" prop="txIdUrl" label="交易号" align="center"></el-table-column>

          <el-table-column width="160" prop="remark" label="申请备注" align="center">
            <template slot-scope="{ row }">
              <div v-if="row.remark">
                <el-popover v-if="row.remark.length > 10" placement="top-start" width="300" trigger="hover"
                  :content="row.remark">
                  <div slot="reference" class="remark">{{ row.remark }}</div>
                </el-popover>
                <div v-else>{{ row.remark }}</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column width="120" prop="agentId" label="agentId" align="center"></el-table-column>

          <!-- <el-table-column
          width="120"
          prop="dealUserName"
          label="处理人"
          align="center"
        >
          <template slot-scope="{ row }">
            <div v-if="row.dealUserName">{{ row.dealUserName }}</div>
            <div v-else>--</div>
          </template>
        </el-table-column> -->

          <el-table-column width="160" prop="createTimeFormat" label="创建时间" align="center"></el-table-column>

          <el-table-column fixed="right" label="操作" width="160" align="center"
            v-if="$store.state.roleId == '1070960390067716097'">
            <template slot-scope="{ row }">
              <el-button type="primary" size="mini" plain :disabled="row.status === '00' ? false : true"
                @click="handleApprove('01', row)">通过</el-button>
              <el-button type="danger" size="mini" plain :disabled="row.status === '00' ? false : true"
                @click="handleApprove('02', row)">拒绝</el-button>
            </template>
          </el-table-column>
        </template>
      </page>
    </div>
    <adopt :is-show-adopt-dialog.sync="isShowAdoptDialog" :id="id" :item="item"></adopt>
    <refuse :is-show-refuse-dialog.sync="isShowRefuseDialog" :id="id"></refuse>
    <operate :is-show-operate-dialog.sync="isShowOperateDialog" :id="id" :type="1" :item="item"></operate>
  </div>
</template>

<script>
import Page from '@/components/Page.vue'
import Adopt from './components/adopt.vue'
import Refuse from './components/refuse.vue'
import Operate from './components/operate.vue'

export default {
  name: 'Systems',
  components: {
    page: Page,
    adopt: Adopt,
    refuse: Refuse,
    operate: Operate
  },

  data() {
    return {
      url: '/depositWithdraw/selectList?type=00',
      action: '',
      timeDate: [],
      form: {
        appId: '',
        startDate: '',
        endDate: '',
        tradeOrderId: '',
      },
      showDialog: false,
      formData: null,
      totalAmount: '',
      totalFee: '',
      totalActualAmount: '',
      merchantList: [],
      isShowAdoptDialog: false,
      isShowRefuseDialog: false,
      id: '',
      item: {},
      isShowOperateDialog: false
    }
  },
  methods: {
    timeChange(e) {
      console.log(this.timeDate)
      if (e) {
        this.form.startDate = e[0]
        this.form.endDate = e[1]
      } else {
        this.form.startDate = ''
        this.form.endDate = ''
      }
    },
    reset() {
      this.timeDate = []
    },
    add() {
      this.action = 'addWithdraw'
      this.formData = null
      this.showDialog = true
    },
    handleApprove(type, row) {
      this.item = row
      this.id = row.orderId
      if (type == '01') {
        this.isShowAdoptDialog = true
      } else {
        this.isShowRefuseDialog = true
      }
    },
    confirm(row) {
      this.$confirm('确定代付出款吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.axios
            .post('/withdraw/confirm', { orderId: row.orderId })
            .then(res => {
              if (res.code === 200) {
                this.$bus.$emit('refresh') //通知刷新
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
        })
        .catch(() => { })
    },
    setSuccess(row) {
      this.$confirm('确认设置为成功吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.axios
            .post('/withdraw/setSuccess', { orderId: row.orderId })
            .then(res => {
              if (res.code === 200) {
                this.$bus.$emit('refresh') //通知刷新
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
        })
        .catch(() => { })
    },
    exportDetail() {
      this.axios
        .get('/withdraw/exportDetail', { params: this.form })
        .then(res => {
          if (res.code === 200) {
            window.location.href =
              '/common/downloadFile?fileId=' + res.data.fileId
          } else {
            this.$notify.error({
              title: '提示',
              message: res.msg,
            })
          }
        })
    },
    reject(row) {
      this.$prompt('请输入驳回原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          this.axios
            .get('/withdraw/reject', {
              params: {
                orderId: row.orderId,
                rejectMessage: value,
              },
            })
            .then(res => {
              this.$bus.$emit('refresh') //通知刷新
              this.$notify.error({
                title: '提示',
                message: res.msg,
              })
            })
        })
        .catch(() => { })
    },

    handleOperType(row) {
      this.item = row
      this.id = row.orderId
      this.isShowOperateDialog = true
    }
  },
  created() {
    this.$axios
      .get('/merchant/selectListForOption', { params: {} })
      .then(res => {
        this.merchantList = res.data
        if (this.merchantList.length == 1) {
          this.form.appId = this.merchantList[0].value
          this.$bus.$emit('refresh')
        }
      })
  },
}
</script>

<style scoped>
.el-button--primary.is-disabled,
.el-button--primary.is-disabled:hover,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:active,
.el-button--danger.is-disabled,
.el-button--danger.is-disabled:hover,
.el-button--danger.is-disabled:focus,
.el-button--danger.is-disabled:active {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
}

.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>